import React, { Component } from 'react';
import profileInfoFakeAvatar from '../../../../../shared/images/profile-info-fake-avatar.png';
import AlertLevel from '../../../../../shared/alert-level/AlertLevel';
import { ContentBox } from '../../../../../shared/content-box/ContentBox';

export class PlayerInfo extends Component {
    getPlayerDetailsContent() {
        return this.props.loaded ? (
            <div style={{ display: 'flex', flexDirection: 'row' }}>
                <div style={{ flex: '10%' }}>
                    <img alt={'Player Avatar'} src={profileInfoFakeAvatar} />
                </div>
                <div style={{ flex: '90%', marginLeft: '42px' }}>
                    <div
                        style={{
                            display: 'flex',
                            flexDirection: 'row',
                            marginBottom: '19px'
                        }}
                    >
                        <span className="player-name">
                            {this.props.player.name +
                                ' ' +
                                this.props.player.surname}
                        </span>
                        <span className="player-id-profile">
                            {this.props.player.id}
                        </span>
                    </div>
                    <div
                        style={{
                            display: 'flex',
                            flex: '70%',
                            flexDirection: 'row',
                            justifyContent: 'space-between'
                        }}
                    >
                        <div
                            style={{
                                display: 'flex',
                                flexDirection: 'column'
                            }}
                        >
                            <span style={{ marginBottom: '11px' }}>
                                <span className="info-label">Location</span>
                                <span className="info-text">
                                    {this.props.player.country}
                                </span>
                            </span>
                            <span style={{ marginBottom: '11px' }}>
                                <span className="info-label">Email</span>
                                <span className="info-text">
                                    {this.props.player.email}
                                </span>
                            </span>
                            <span>
                                <span className="info-label">Birthday</span>
                                <span className="info-text">
                                    {this.props.player.dateOfBirth}
                                </span>
                            </span>
                        </div>
                        <div
                            style={{
                                display: 'flex',
                                flexDirection: 'column'
                            }}
                        >
                            <span style={{ marginBottom: '11px' }}>
                                <span className="info-label">
                                    Alerts Dismissed for this Player
                                </span>
                                <span className="info-text">
                                    {this.props.player.alertsDismissed}
                                </span>
                            </span>
                            <span style={{ marginBottom: '11px' }}>
                                <span className="info-label">
                                    Alerts Active for this player
                                </span>
                                <span className="info-text">
                                    {this.props.player.activeAlerts}
                                </span>
                            </span>
                            <span>
                                <span className="info-label">Overall Risk</span>
                                <span className="info-text">
                                    <AlertLevel
                                        level={this.props.player.riskLevel}
                                    />
                                </span>
                            </span>
                        </div>
                        <div
                            style={{
                                display: 'flex',
                                flexDirection: 'column'
                            }}
                        >
                            {/*<span style={{marginBottom: '11px'}}>*/}
                            {/*<span className='info-label'>Overall Risk</span>*/}
                            {/*<span className='info-text'>*/}
                            {/*<AlertLevel level={this.props.player.riskLevel}/>*/}
                            {/*</span>*/}
                            {/*</span>*/}
                            <span style={{ marginBottom: '11px' }}>
                                <span className="info-label">AML Risk</span>
                                <span className="info-text">
                                    <AlertLevel
                                        level={this.props.player.amlRiskLevel}
                                    />
                                </span>
                            </span>
                            <span style={{ marginBottom: '11px' }}>
                                <span className="info-label">
                                    Responsible Gaming Risk
                                </span>
                                <span className="info-text">
                                    <AlertLevel
                                        level={this.props.player.rgRiskLevel}
                                    />
                                </span>
                            </span>
                            <span>
                                <span className="info-label">Fraud Risk</span>
                                <span className="info-text">
                                    <AlertLevel
                                        level={this.props.player.fraudRiskLevel}
                                    />
                                </span>
                            </span>
                        </div>
                    </div>
                </div>
            </div>
        ) : (
            <div>Loading...</div>
        );
    }

    render() {
        return (
            <ContentBox
                contentBoxStyle={'content-box no-margin'}
                title="Player Info"
                content={this.getPlayerDetailsContent()}
            />
        );
    }
}
